import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0b50738"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "description-subtitle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startPeriodSelector" }, " Start Period: ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endPeriodSelector" }, " End Period: ", -1))
const _hoisted_6 = { class: "button-group" }
const _hoisted_7 = ["disabled"]

import '@vuepic/vue-datepicker/dist/main.css';
import {ref,computed} from 'vue';
import Popup from '@/components/Popup.vue';
import PeriodSelector from '@/components/PeriodSelector.vue';
import DatePeriod from '@/types/DatePeriod';
import useNotifierWithErrFormatter from '@/services/composables/NotifierWithErrFormatter';


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiplePeriodEoPVerificationReportPopUp',
  props: {
    modelValue: { type: Boolean },
    period: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const displayingForm = computed({
    get(){
        return props.modelValue;
    },
    set(val: boolean) {
        emits('update:modelValue', val);
    }
});
const working = ref(false);
const startPeriod = ref<DatePeriod>(new DatePeriod(props.period ? new Date(props.period) : new Date().addMonths(-1)));
const endPeriod = ref<DatePeriod>(new DatePeriod(props.period ? new Date(props.period) : new Date().addMonths(-1)));
function closeChild() {
    displayingForm.value = false;
}
function validatePeriods(startP : DatePeriod, endP : DatePeriod) {
    let validationResult = true;
    if( !!startP && !!endP) {
        if (endP < startP) {
            validationResult = false;
            useNotifierWithErrFormatter().warn({
                msg: "End Period must not be earlier than Start Period"
            })
        }
    }
    else {validationResult = false}
    return validationResult;
}
async function confirmPeriods() {
    if (!validatePeriods(startPeriod.value, endPeriod.value) ) return;
    emits('confirm', startPeriod.value, endPeriod.value);
    emits('update:modelValue', false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: displayingForm.value,
    "onUpdate:modelValue": closeChild,
    title: "Create New Multiple Period Report:",
    hasClose: ""
  }, {
    contents: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          class: "two-column",
          onSubmit: _withModifiers(confirmPeriods, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(PeriodSelector, {
              ref: "startPeriodSelector",
              id: "startPeriodSelector",
              class: "col2 select",
              type: "text",
              title: "Select start period",
              modelValue: startPeriod.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startPeriod).value = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_5,
            _createVNode(PeriodSelector, {
              ref: "endPeriodSelector",
              id: "endPeriodSelector",
              class: "col2 select",
              type: "text",
              title: "Select end period",
              modelValue: endPeriod.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endPeriod).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              disabled: working.value,
              class: "confirm-button",
              type: "submit"
            }, " Confirm ", 8, _hoisted_7)
          ])
        ], 40, _hoisted_2)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})